"use client";

import { SuccessScreen } from "@/modules/success/views/success-screen";

export function SuccessPage() {
  return <SuccessScreen />;
}
